import { ITooltip } from '@components';
import { ITagNReq, ITagReq } from './Tag.types';

import { Container, TagDiv } from './Tag.styles';

type TagProps = ITagNReq | ITagReq;

const Tag = ({
  tagName,
  tagCategory,
  color,
  disableCategoryTip,
  id,
}: TagProps) => {
  const TooltipText = () => {
    if (tagCategory) return `Category: ${tagCategory}`;
    return 'Uncategorized';
  };
  return (
    <Container>
      <TagDiv
        limitOfLines={1}
        color={color}
        data-for={id}
        data-tip={TooltipText()}
      >
        {tagName}
      </TagDiv>

      <ITooltip id={id} disable={disableCategoryTip} />
    </Container>
  );
};

export { Tag };
